export const frxAppOptions = [
  { label: "Add Gift Card", value: "add_gift_card" },
  { label: "Buy Gift Card", value: "buy_gift_card" },
  { label: "Blog", value: "ArticleDetail" },
  { label: "Carpark$", value: "CarparkMainPage" },
  { label: "DGC Buy for Friend", value: "BuyForFriendCardArt" },
  { label: "DGC Buy for Myself", value: "BuyForMySelf" },
  { label: "External Link", value: "NA"},
  { label: "e-wallet",value: "ewallet",
    params:{"CampaignMedium":"","Link":""}},
  { label: "Frasers Points", value: "frasers_point" },
  { label: "Member Spending", value: "FRxMemberSpending"},
  { label: "Partner Rewards", value: "PartnerRewards" },
  { label: "Profile", value: "UserProfile" },
  { label: "QR", value: "ShowQR" },
  { label: "Refer a friend", value: "ReferFriend" },
  { label: "Rewards", value: "RewardsTab" },
  { label: "UOB UNI$", value: "UobUni" },
  { label: "No Navigation", value: "" },
];

export const mallOptions = [
  { label: "Causeway Point", value: "cwp" },
  { label: "Eastpoint Mall", value: "epm" },
  { label: "Northpoint City", value: "npc" },
  { label: "The Centrepoint", value: "tcp" },
  { label: "Century Square", value: "cs" },
  { label: "Hougang Mall", value: "hm" },
  { label: "Tampines 1", value: "t1" },
  { label: "Tiong Bahru Plaza", value: "tbp" },
  { label: "White Sands", value: "ws" },
  { label: "Waterway Point", value: "wwp" },
  { label: "FRx", value: "frx" },
  { label: "Robertson Walk", value: "rw" }
];

export const happeningTypeOptions = [
  { value: "Promotions", label: "Promotions" },
  { value: "Offers", label: "Offers" },
  { value: "Blogs", label: "Blogs" },
  { value: "Happenings", label: "Events"},
];